import { getWordOrRoot } from './dictionary.js';

// Strip leading/trailing quotes and all other punctuation, but preserve
// mid-word apostrophes so contractions like "don't" survive tokenization
// (the CDN vocab list stores them with apostrophes intact).
const PUNCT_RE = /^['"]|['"]$|[.,!?;:()[\]{}]/g;

/** Strip punctuation and lowercase a word for dictionary lookup. */
export function cleanWord(raw) {
  return raw.replace(PUNCT_RE, '').toLowerCase();
}

/**
 * Split sentence text into an ordered array of tokens with dictionary
 * lookup already resolved. Whitespace is preserved as its own entries
 * so callers can reconstruct the original text verbatim.
 *
 * Each token: { raw, clean, dictEntry, isSpace }.
 */
export function splitToClickableWords(text) {
  return text.split(/(\s+)/).map((part) => {
    if (/^\s+$/.test(part)) {
      return { raw: part, clean: '', dictEntry: null, isSpace: true };
    }
    const clean = cleanWord(part);
    const dictEntry = clean ? getWordOrRoot(clean) : null;
    return { raw: part, clean, dictEntry, isSpace: false };
  });
}
